import styled from "styled-components";

export const TffMessage = styled.p`
  font-size: 16px;
  font-style: italic;
  line-height: 16px;
  margin-top: var(--spacer-m);
`;
